import { Icon } from '../../../../Product/components/Icon';
import { OrderHistoryItemsLayout } from './OrderHistoryItemsLayout';

type HistoryItemProps = {
	product: { id: string; name: string };
};

export const OrderHistoryItems: React.FC<HistoryItemProps> = ({
	product,
	...props
}) => {
	return (
		<OrderHistoryItemsLayout
			icon={<Icon {...product} />}
			name={product.name}
			{...props}
		/>
	);
};
